function showWait() {
  document.getElementById("wait").style.display = 'block'
}
function hideWait() {
  document.getElementById("wait").style.display = 'none';
}
function change1(gv) {
  document.getElementById("g2").style.display = 'block';
  selectText(gv);
  setTimeout(function () {
    document.getElementById("g2").style.display = 'none';
  }, 20000);

}

function doclick() {
  var td = event.srcElement.parentElement; // 通过event.srcElement 获取激活事件的对象 td
  //alert("行号：" + (td.parentElement.rowIndex) + "，内容：" + td.cellIndex);

  var idx = td.parentElement.rowIndex;
  if (idx != undefined ) {
    if (idx > 0) {
      var g1 = document.getElementById("GridView2").rows[idx].innerHTML;
      document.getElementById("GridView1").rows[idx].innerHTML = g1;
    } else  {
      change("GridView2");
    }
  }
}

function selectText(element) {
  var text = document.getElementById(element);
  if (document.body.createTextRange) {
    var range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();

    console.log("copy1");
  } else if (window.getSelection) {
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
    /*if(selection.setBaseAndExtent){
     selection.setBaseAndExtent(text, 0, text, 1);
    }*/
    console.log("copy2");
  } else {
    alert("none1");
  }
  document.execCommand("copy");
}

export default {
  selectText: function(element){
    selectText(element);
  }

}



// WEBPACK FOOTER //
// ./src/api/copy.js